<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue';

import { formatDuration } from '~/common/DateUtils';

const ONE_DAY_MS = 24 * 60 * 60 * 1000;

const props = defineProps({
  startDate: {
    type: Date,
    required: true,
  },
  endDate: {
    type: Date,
    required: true,
  },
  mergeDate: {
    type: Date,
    required: true,
  },
});

const countdownText = ref('');
const isInProgress = ref(false);
const countdownTimer = ref(null);

const displayDate = (date, isEndDate = false) => {
  const day = date.getUTCDate() + (isEndDate ? 1 : 0);
  const locale = navigator.language || 'default';
  const monthName = date.toLocaleString(locale, {
    month: 'long',
    timeZone: 'UTC',
  });

  return `${monthName} ${day}`;
};

const updateCountdown = () => {
  const now = Date.now();

  const timeToStart = props.startDate - now;
  const timeToEnd = (props.endDate - now) + ONE_DAY_MS;
  const timeToMerge = props.mergeDate - now;

  // Determine what phase we're in
  if (timeToStart > 0) {
    // Before hackathon
    countdownText.value = `Hackathon starts in: ${formatDuration(timeToStart)}`;
  } else if (timeToEnd > 0) {
    // During hackathon
    isInProgress.value = true;
    countdownText.value = `Hackathon ends in: ${formatDuration(timeToEnd)}`;
  } else if (timeToMerge > 0) {
    // During merge window
    countdownText.value = `Merge window closes in: ${formatDuration(timeToMerge)}`;
  } else {
    // After everything
    countdownText.value = 'Hackathon completed!';
  }
};

onMounted(() => {
  updateCountdown();
  countdownTimer.value = setInterval(updateCountdown, 1000);
});

onBeforeUnmount(() => {
  if (countdownTimer.value) {
    clearInterval(countdownTimer.value);
  }
});
</script>

<template>
  <div class="mx-auto p-2 mt-3 text-center">
    <h3
      v-if="Date.now() < startDate"
      class="fw-light"
    >
      Join us from {{ displayDate(startDate) }} to {{ displayDate(endDate, true) }}
    </h3>
    <h3
      v-if="isInProgress"
      class="fw-light"
    >
      Hackathon in progress!
    </h3>
    <h3 class="fw-light">{{ countdownText }}</h3>
  </div>
</template>
